import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { ApiError, ApplicationError } from './error';

@Injectable({
  providedIn: 'root'
})
export class ExceptionService {

  // TODO: should be HttpErrorResponse instead any after moving on HttpClient
  private errorResponseSubject = new Subject<any>();
  private errorApiSubject = new Subject<ApiError>();
  private errorAppSubject = new Subject<ApplicationError>();

  constructor() { }

  // TODO: should be HttpErrorResponse instead any after moving on HttpClient
  public get responseErrors(): Observable<any> {
    return this.errorResponseSubject.asObservable();
  }

  public get apiErrors(): Observable<ApiError> {
    return this.errorApiSubject.asObservable();
  }

  public get appErrors(): Observable<ApplicationError> {
    return this.errorAppSubject.asObservable();
  }

  public handle(error: any): Promise<any> {
    this.handleInternal(error);
    return Promise.resolve(error.message || error);
  }

  public handleSync(error: any): void {
    this.handleInternal(error);
  }

  private handleInternal(error: any) {
    try {

      if (!error) {
        // An empty error cannot be handled
        return;
      }

      const errorObj = error.hasOwnProperty('rejection')
        ? error.rejection
        : error;

      const errorResponse = errorObj.status
        && (<Response>errorObj || <HttpErrorResponse>errorObj);

      const apiError =
        error && error.error && error.error.errors
          ? <ApiError>error.error
          : undefined;

      const appError = errorObj.message && <ApplicationError>error;

      if (apiError) {

        // Backend Handled Api Error (with backend-added .errors)
        this.errorApiSubject.next(apiError);
        return;

      }

      if (appError && !errorResponse) {

        // TODO: error.message < 500

        // Application Error
        this.errorAppSubject.next(appError);

        return;

      }

      if (errorResponse) {

        // Simple Api Error
        this.errorResponseSubject.next(errorResponse);

        return;

      }

    } catch (exception) {
      console.log('Caught an exception in Exception service');
      console.error(exception);
    }
  }
}
